export interface IPatientScreen {
    id: number,
    preferredCenterId: number,
    medicalRecordId: number,
    entryDomain: string,
    agreedToHipaa: boolean,
    isOptedOut: boolean,

    currentStatusId: number,
    currentStatus: string,

    kidneyStatusId: number,
    kidneyStatus: string,
    kidneyStatusOther: string,

    hasTranplantCenter: boolean,
    isWillingToTransfer: boolean,

    donorStatusId: number,
    donorStatus: string,
    donorStatusOther: string,

    primaryGoalId: number,
    primaryGoal: string,
    priamryGoalOther: string
}